export default {"src":"/_next/static/media/zhaket-orange-logo.93ba52ce.svg","height":62,"width":85,"blurWidth":0,"blurHeight":0};